import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import FontsConfig from "../model/FontsConfig";
import FontLoaderService, { FontLoaderError } from "./FontLoaderService";

export default class PreloadFontsTask extends Task {
    /**
     * 
     * @param {FontsConfig} fontsConfig
     * @param {FontLoaderService} fontLoaderService
     */
    constructor(fontsConfig, fontLoaderService){
        super();
        this._fontsConfig = fontsConfig;
        this._fontLoaderService = fontLoaderService;
    }

    execute(callback, _){
        let fonts = this._fontsConfig.getFontsFromGroups("common");
        this._fontLoaderService.load(fonts, { verbose: true }).then(result =>{
            console.log("[PreloadFontsTask] Fonts finished loading", result);
        }).catch(e => {
            if(e instanceof FontLoaderError) {
                console.error("[PreloadFontsTask] Fonts failed loading!", e.result.fail);
            } else {
                throw e;
            }
        }).finally(() => {
            callback(this);
        });
    }
}